export const scryfallFormats = [
  { value: "commander", label: "Commander" },
  { value: "standard", label: "Standard" },
  { value: "future", label: "Future Standard" },
  { value: "historic", label: "Historic" },
  { value: "timeless", label: "Timeless" },
  { value: "gladiator", label: "Gladiator" },
  { value: "pioneer", label: "Pioneer" },
  { value: "modern", label: "Modern" },
  { value: "legacy", label: "Legacy" },
  { value: "pauper", label: "Pauper" },
  { value: "vintage", label: "Vintage" },
  { value: "penny", label: "Penny Dreadful" },
  { value: "oathbreaker", label: "Oathbreaker" },
  { value: "standardbrawl", label: "Standard Brawl" },
  { value: "brawl", label: "Brawl" },
  { value: "alchemy", label: "Alchemy" },
  { value: "pauper-commander", label: "Pauper Commander" },
  { value: "duel", label: "Duel Commander" },
  { value: "oldschool", label: "Old School 93/94" },
  { value: "premodern", label: "Premodern" },
  { value: "predh", label: "PreDH" },
] as const;

export type ScryfallFormat = (typeof scryfallFormats)[number]['value'];

export function isScryfallFormat(value: string): value is ScryfallFormat {
  return scryfallFormats.some((format) => format.value === value);
}